import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    color: {
      title: 'Kolor',
      type: 'string',
      fieldRequired: true
    },
    icon: {
      title: 'Ikona',
      type: 'string',
      fieldRequired: false
    },
    action: {
      title: 'Akcja',
      type: 'string',
      fieldRequired: '!this.routeName',
      validationMessages: {
        required: 'Błąd: Należy wybrać akcję lub widok.'
      }
    },
    actionData: {
      title: 'Dane akcji',
      type: 'string',
      fieldRequired: '!!this.action'
    },
    routeName: {
      title: 'Widok',
      type: 'string',
      fieldRequired: '!this.action',
      validationMessages: {
        required: 'Błąd: Należy wybrać akcję lub widok.'
      }
    },
    statusId: {
      title: 'Status',
      type: 'number',
      fieldRequired: true
    },
    order: {
      title: 'Kolejność',
      type: 'number',
      fieldRequired: true
    },
    roleIds: {
      title: 'Uprawnione role',
      type: 'array',
      minItems: 1,
      items: {
        type: 'number'
      }
    }
  },
  allOf: [validationMessages]
};
